"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var toolkit_1 = require("@reduxjs/toolkit");
var constants_1 = require("./constants");
var initialState = {
    devices: [],
    isConnected: false,
    isReadyToCast: false,
    isAttemptingToCast: false,
    isDeviceModalOpen: false,
    isConnecting: false,
    connectingError: null,
    connectedDevice: null,
    casting: {
        data: {},
        isLoading: false,
        error: null,
    },
    isPlayerExpanded: false,
    isPlayerSeasonsSelectorVisible: false,
    volume: null,
};
var reducers = (_a = {},
    _a[constants_1.SET_DEVICES] = function (state, action) { return (__assign(__assign({}, state), { devices: action.payload })); },
    _a[constants_1.SET_CONNECTED_DEVICE] = function (state, action) { return (__assign(__assign({}, state), { connectedDevice: action.payload })); },
    _a[constants_1.SET_CASTING_IS_LOADING] = function (state, action) { return (__assign(__assign({}, state), { casting: __assign(__assign({}, state.casting), { isLoading: action.payload }) })); },
    _a[constants_1.SET_CASTING_DATA] = function (state, action) { return (__assign(__assign({}, state), { casting: {
            data: action.payload,
            isLoading: false,
            error: null,
        } })); },
    _a[constants_1.SET_IS_CONNECTED] = function (state, action) { return (__assign(__assign({}, state), { isConnected: action.payload, isConnecting: action.payload ? false : state.isConnecting })); },
    _a[constants_1.SET_IS_READY_TO_CAST] = function (state, action) { return (__assign(__assign({}, state), { isReadyToCast: action.payload })); },
    _a[constants_1.SET_IS_ATTEMPTING_TO_CAST] = function (state, action) { return (__assign(__assign({}, state), { isAttemptingToCast: action.payload })); },
    _a[constants_1.SET_IS_DEVICE_MODAL_OPEN] = function (state, action) { return (__assign(__assign({}, state), { isDeviceModalOpen: action.payload })); },
    _a[constants_1.SET_IS_CONNECTING] = function (state, action) { return (__assign(__assign({}, state), { isConnecting: action.payload, isConnected: action.payload ? false : state.isConnected })); },
    _a[constants_1.SET_IS_PLAYER_EXPANDED] = function (state, action) { return (__assign(__assign({}, state), { isPlayerExpanded: action.payload, isPlayerSeasonsSelectorVisible: false, isPlayerDisconnectVisible: false })); },
    _a[constants_1.SET_IS_PLAYER_SEASONS_SELECTOR_VISIBLE] = function (state, action) { return (__assign(__assign({}, state), { isPlayerSeasonsSelectorVisible: action.payload })); },
    _a[constants_1.CONNECTING_ERROR] = function (state, action) { return (__assign(__assign({}, state), { connectingError: action.payload })); },
    _a[constants_1.CASTING_ERROR] = function (state, action) { return (__assign(__assign({}, state), { casting: __assign(__assign({}, state.casting), { isLoading: false, error: action.payload }) })); },
    _a[constants_1.SET_VOLUME_LEVEL] = function (state, action) { return (__assign(__assign({}, state), { volume: action.payload })); },
    _a);
exports.default = toolkit_1.createReducer(initialState, reducers);
//# sourceMappingURL=reducer.js.map